var $e97402d4778a500f$exports = {};
$e97402d4778a500f$exports = {
    "longPressMessage": `Pressione e segure ou pressione Alt + Seta para baixo para abrir o menu`
};


export {$e97402d4778a500f$exports as default};
//# sourceMappingURL=pt-BR.mjs.map
